import React from "react";

/**
 * Brass-style toggle switch. Used across user/experience rows and the
 * new-user modal. Visual: 11×6 pill, brass when on, mist when off.
 */
export default function Toggle({ on, onChange, testid }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      data-testid={testid}
      onClick={() => onChange(!on)}
      className={`relative inline-flex h-6 w-11 items-center transition-colors ${
        on ? "bg-brass" : "bg-mist"
      }`}
      style={{ borderRadius: 999 }}
    >
      <span
        className={`inline-block h-5 w-5 bg-ivory transition-transform ${
          on ? "translate-x-5" : "translate-x-0.5"
        }`}
        style={{ borderRadius: 999 }}
      />
    </button>
  );
}
